export const nodeAddress = process.env.REACT_APP_NODE_ADDRESS;
export const nodePort = process.env.REACT_APP_NODE_PORT;
export const mwUrl = process.env.REACT_APP_MW_URL;
export const companyPhoneNo = process.env.REACT_APP_COMPANY_PHONE_NO;
export const companyEmail = process.env.REACT_APP_COMPANY_EMAIL;
